import React, {useState} from 'react';

import {Box,useMediaQuery, useTheme} from '@mui/material';

import {DndContext, DragOverlay, MouseSensor, TouchSensor, useSensor, useSensors} from '@dnd-kit/core';
import {restrictToWindowEdges, snapCenterToCursor} from '@dnd-kit/modifiers';

import {CANVAS_HEIGHT, CANVAS_WIDTH} from 'canvas/canvas-helper';
import {getNextPlayerNumber} from 'canvas/Drawer/player-utils';
import {useCanvasStore} from 'canvas/zustand';
import PlayerBadge from 'layout/components/toolbar/components/PlayerBadge';
import PlayerCircle from 'layout/components/toolbar/components/PlayerCircle';
import PlayerShirt from 'layout/components/toolbar/components/PlayerShirt';
import {createPlayer} from 'module/client/team/useLineup';
import {useLayoutStore} from 'store';
import {usePrefsStore} from 'store';

const vibrate = (pattern) => {
    if (navigator.vibrate) {
        navigator.vibrate(pattern);
    }
};

const getDraggableElement = (data) => {
    const colors = data?.current?.colors;
    const player = data?.current?.player;
    const type = data?.current?.player?.type;
        
    switch (type) {
    case 'playerCircle':
        return <PlayerCircle number={player.number} colors={colors} />;
    case 'player':
        return <PlayerShirt number={player.number} colors={colors} />;
    case 'playerCircleImage':
        return <PlayerBadge player={player} colors={colors} />;
    default:
        return 'NOT PROVIDED';
    }
};

const DnD = ({children}) => {
    const canvas = useCanvasStore(state => state.canvas);

    const prefs = usePrefsStore((state) => state.prefs.player);
    const theme = useTheme();

    const setLineupIsDragging = useLayoutStore((state) => state.setLineupIsDragging);
    const lineupIsDragging = useLayoutStore((state) => state.lineupIsDragging);
    const [draggableElementData, setDraggableElementData] = useState(null);
    const [dropping, setDropping] = useState(false);
    const isMobile = useMediaQuery(theme.breakpoints.down('md'));

    const mouseSensor = useSensor(MouseSensor);
    const touchSensor = useSensor(TouchSensor);

    const sensors = useSensors(
        mouseSensor,
        touchSensor,
    );

    const handleDragStart = (e) => {
        // console.log('dragstart', e?.active?.data);
        // hide drawer if dragging on mobile 
        // type is needed to clone the active drag element when dragging on mobile
        setLineupIsDragging(e?.active?.data?.current?.player?.type || true);
        // used for cloning the active drag element when dragging
        setDraggableElementData(e?.active?.data);

        if (isMobile) {
            vibrate([200, 100, 200]);
        }
    };

    const handleDragMove = (_e) => {
        // console.log(e.activatorEvent.target.getBoundingClientRect());
        // console.log('move', e.delta.x, e.delta.y, e.activatorEvent.x, e.activatorEvent.y);
        // const viewPortPos = e.activatorEvent.target.getBoundingClientRect(); // viewport position of the draggable
        // console.log('move', viewPortPos.x, viewPortPos.y);
    };

    const handleDragEnd = (e) => {
        // console.log('dragend', e);
        console.log('dragend', e.active.data.current);
        setDropping(true);
        setTimeout(() => {
            setLineupIsDragging(false);
            setDraggableElementData(null);
            setDropping(false);
        }, 200);

        if (isMobile) {
            vibrate([200, 100, 200]);
        }
        
        const team = e.active.data.current.team;
        const player = e.active.data.current.player;
        const type = e.active.data.current.player.type;
        const colors = e.active.data.current.colors;
        
        if (!canvas) return;
        
        const canvasViewPort = canvas.lowerCanvasEl.getBoundingClientRect();
        const viewPortPos = e.activatorEvent.target.getBoundingClientRect(); // viewport position of the draggable
        
        const scale = 1 / canvas.getZoom();
        let x = viewPortPos.x - canvasViewPort.x + (viewPortPos.width / 2);
        let y = viewPortPos.y - canvasViewPort.y + (viewPortPos.height / 2);

        x = Math.round(x * scale);
        y = Math.round(y * scale);

        if (e.over?.id !== 'canvas-container' || x > CANVAS_WIDTH || x < 0 || y > CANVAS_HEIGHT || y < 0) {
            return;
        }

        if (player && team) {
            // has a selected team
            const teamPrefs = team.prefs.player;
            const image = player.user?.image || null;
            // console.log('dragend create player - team', player, type || teamPrefs.type || prefs.type, teamPrefs, image);
            createPlayer(canvas, player, type || teamPrefs.type || prefs.type,
                colors,
                prefs.size,
                image,
                x, y,
                {
                    team: team.id,
                    playerId: player.id,
                    position: player.position
                }
            );
        } else if (player) {
            console.log('dragend create player - NO TEAM', player,type || prefs.type);

            player.number = getNextPlayerNumber(canvas, player.team);

            // prefs.type
            createPlayer(canvas, player, player.type,
                colors,
                prefs.size,
                null,
                x, y,
                {
                    team: player.team,
                }
            );
        }

        // console.log(canvas);
    };

    return <DndContext
        modifiers={[snapCenterToCursor]}
        sensors={sensors} onDragStart={handleDragStart} onDragEnd={handleDragEnd}
        onDragMove={handleDragMove}>
        {children}
        <DragOverlay modifiers={[restrictToWindowEdges]}>
            {(lineupIsDragging && draggableElementData) ?
                <Box sx={{
                    transform: dropping ? 'scale(0.5)' : 'scale(1.25)',
                    transition: dropping ? 'transform 0.2s ease-in' : 'transform 0.15s ease-out',
                }}>
                    {getDraggableElement(draggableElementData)}
                </Box>
                : null}
        </DragOverlay>
    </DndContext>;
};

export default DnD;
